import React from "react";
import "./shared.css";
import "./featuredClient.css";
import { Helmet } from "react-helmet";

function FeaturedClients() {
  return (
    <main className="featuredClientsPage">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Featured Clients | Radix Software Solutions</title>
        <meta
          name="description"
          content="Client spotlights showcasing Radix Software Solutions partnerships and results across reporting, integrations, and automation."
        />
        <meta
          property="og:title"
          content="Featured Clients | Radix Software Solutions"
        />
        <meta
          property="og:description"
          content="Client spotlights showcasing Radix Software Solutions partnerships and results across reporting, integrations, and automation."
        />
        <meta property="og:site_name" content="Radix Software Solutions" />
        <meta
          property="og:url"
          content="https://www.radixsoftwaresolutions.com/featured-clients"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Featured Clients | Radix Software Solutions"
        />
        <meta
          name="twitter:description"
          content="Client spotlights showcasing Radix Software Solutions partnerships and results across reporting, integrations, and automation."
        />
        <link
          rel="canonical"
          href="https://www.radixsoftwaresolutions.com/featured-clients"
        />
      </Helmet>

      <section className="section featuredClientsHero">
        <div className="pageContainer">
          <p className="sectionKicker">Featured Clients</p>
          <h1 className="featuredClientsTitle">Featured Clients</h1>
          <p className="paragraphTextStyle featuredClientsIntro">
            A few partnerships that highlight the outcomes Radix delivers in
            reporting, integrations, and automation.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="pageContainer">
          <div className="featuredClientsGrid">
            <article className="card clientCard">
              <div className="clientHeader">
                <a
                  href="https://topshelfmeats.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="clientLogoLink"
                >
                  <div className="clientLogoWrap" style={{ backgroundColor: "black" }}>
                    <img
                      src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Browns-TopShelf-Meats_logo.png"
                      alt="Browns Top Shelf Meats Badge Icon"
                    />
                  </div>
                </a>
                <div>
                  <h2 className="cardTitle">Browns Top Shelf Meats</h2>
                  <p className="clientType">Ecommerce + Operations</p>
                </div>
              </div>
              <p className="paragraphTextStyle clientQuote">
                I was referred to Nathan at Radix Software Solutions from a
                personal friend of mine that knew I was in desperate need of
                help. I had a problem on my site hosted on Shopify with how my
                product was being shown once added to a shopping cart. Shopify
                had no solution for this nor were there any 3rd party apps
                available to provide a remedy.
              </p>
              <p className="paragraphTextStyle clientQuote">
                In comes Nathan, and no joking, had not only a theory on how to
                fix the issue, but a working test within 1 week. When I say he
                saved my business, I mean it! To add to that, he is great to
                work with as well. Very personable, clear to understand, and
                has great ideas to help. Highly recommend Nathan and Radix!
              </p>
              <p className="paragraphTextStyle clientSignature">
                <em>- Mike Brown, Owner</em>
              </p>
            </article>

            <article className="card clientCard">
              <div className="clientHeader">
                <a
                  href="https://backroadpicking.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="clientLogoLink"
                >
                  <div className="clientLogoWrap">
                    <img
                      src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Badge5.Main.png"
                      alt="Back Road Picking Badge Icon"
                    />
                  </div>
                </a>
                <div>
                  <h2 className="cardTitle">Back Road Picking</h2>
                  <p className="clientType">Brand + Ecommerce</p>
                </div>
              </div>
              <p className="paragraphTextStyle clientQuote">
                As someone who has worked in eCommerce and in Tech (Saas) for
                more than 20 years I wanted to ensure my site was built in a
                manner that was easy to access, from any device, easy for me to
                update, and matched the style of what we are doing. Nate (Radix
                Solutions) hit it out of the park! This site is fantastic! It's
                responsive, the design is fantastic (TY Alexus!) and everything
                works as it should!
              </p>
              <p className="paragraphTextStyle clientQuote">
                Nathan and team took us from a blank slate to a full blown site
                that we love! They took the time to figure out what our style
                was, presented us with options, the patiently worked with us
                (me) when we wanted something changed. You won't go wrong
                working with Radix. They communicate very well and are very
                professional. Great work, thank you so much!
              </p>
              <p className="paragraphTextStyle clientSignature">
                <em>- Kim Wren, Owner</em>
              </p>
            </article>

            <article className="card clientCard">
              <div className="clientHeader">
                <a
                  href="https://paperwishes.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="clientLogoLink"
                >
                  <div className="clientLogoWrap">
                    <img
                      src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/PaperWishes.png"
                      alt="Paper Wishes Badge Icon"
                    />
                  </div>
                </a>
                <div>
                  <h2 className="cardTitle">Paper Wishes</h2>
                  <p className="clientType">Reporting + Operations</p>
                </div>
              </div>
              <p className="paragraphTextStyle clientQuote">
                I was creating a custom report out of SkuVault on a weekly
                basis. It took hours and I always questioned its accuracy. I
                needed to do something different. I was introduced to Nathan at
                Radix Software Solutions who was able to create a report for us
                within a week. Now what took hours, takes minutes. Nathan was
                excellent to work with. He responds quickly and makes sure you
                are happy with his work. I wouldn't hesitate recommending
                Nathan and Radix. I know he will be our go to for any future
                needs.
              </p>
              <p className="paragraphTextStyle clientSignature">
                <em>- Jennifer Foresee, Vice President</em>
              </p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}

export default FeaturedClients;
